// extracted by mini-css-extract-plugin
export var aboveInput = "_ju-0";
export var actionButton = "_ju-5";
export var actionButtonContainer = "_ju-1";
export var actionIcon = "_ju-6";
export var aiInfoContainer = "_ju-2";
export var attachmentWrapper = "_ju-7";
export var bold = "_ju-3";
export var checkIcon = "_ju-8";
export var clickingRecipientBar = "_ju-11";
export var commentThreadSwitch = "_ju-a";
export var draftImage = "_ju-b";
export var draftImageContainer = "_ju-c";
export var draftImages = "_ju-e";
export var editButton = "_ju-g";
export var editor = "_ju-f";
export var editorContainer = "_ju-y";
export var editorErrorTooltipWrapper = "_ju-9";
export var headerDivider = "_ju-h";
export var icon = "_ju-i";
export var info = "_ju-j";
export var internal = "_ju-n";
export var internalDivider = "_ju-k";
export var internalMessage = "_ju-l";
export var messageInputCard = "_ju-m";
export var messageInputForm = "_ju-o";
export var messageInputFormInternal = "_ju-p";
export var options = "_ju-q";
export var publicMessageCustomer = "_ju-s";
export var publicMessageMerchant = "_ju-r";
export var removeImageButton = "_ju-d";
export var replyButtons = "_ju-t";
export var showSignatureButton = "_ju-u";
export var spinner = "_ju-v";
export var verticalButtonDivider = "_ju-4";
export var visibilitySelector = "_ju-w";
export var warning = "_ju-x";
export var wrappingText = "_ju-z";
export var writingInternalNoteTopBorder = "_ju-10";